import { FunctionComponent, useEffect, useState } from 'react';
import styles from './Banner.module.scss';

export interface BannerProps {
  variant?: 'notification';
  label: React.JSX.Element;
  isVisible: boolean;
}

type FC = FunctionComponent<BannerProps>;

const Banner: FC = ({ variant = 'notification', label, isVisible = true }: BannerProps) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(isVisible);
  }, [isVisible]);

  return (
    <>
      {isVisible && (
        <div className={[styles.container, styles[getVariantClass()], styles[getVisibilityClass()]].join(' ')}>
          <div>{label}</div>
        </div>
      )}
    </>
  );

  function getVariantClass() {
    return { notification: 'notification' }[variant];
  }

  function getVisibilityClass() {
    return visible ? 'visible' : '';
  }
};

export default Banner;
